

export default {
  userLoggedIn: [
      {
          Userid: "",
          Email: "",
          Fname: "",
          Lname: "",
          status: false,
          role: "",
          subscription: false,
          _id: "",
          cloudinary_upload: "",
          cloudinary_destory: "",
          apiKeyCloudinary: "",
          apiSecretKeyCloudinary: "",
          apiKey: ""
      }
  ],
  tenants: [
      {
          Userid: "Loading...",
          Email: "Loading...",
          Company: "Loading...",
          Fname: "Loading...",
          Lname: "Loading...",
          Address: "Loading...",
          City: "Loading...",
          State: "Loading...",
          Country: "Loading...",
          Postal: "Loading...",
          Phone: "Loading...",
          Role: "Loading...",
          SubscriptionDate: "Loading...",
          SubscriptionStatus: "Loading...",
          SubscriptionType: "Loading...",
          SubscriptionMultiShopCount: "Loading...",
          SubScriptionPrice: "Loading...",
          CustomerXRef: "Loading...",
          Passsword: "loading...",
          Hash: "Loading...",
          Salt: "Loading...",
      }
],
  tenant:
      {
          Userid: "",
          Email: "",
          Company: "",
          Fname: "",
          Lname: "",
          Address: "",
          City: "",
          State: "",
          Country: "",
          Postal: "",
          Phone: "",
          Role: "",
          SubscriptionDate: "",
          SubscriptionStatus: false,
          SubscriptionType: "",
          SubscriptionMultiShopCount: 0,
          SubscriptionPrice: 0,
          CustomerXRef: "",
          Password: "",
          ConfirmPassword: "",
          Hash: "",
          Salt: "",
    },


    subscriptions: [
        {
            RequestingTenantId: "Loading...",
            EventType: "Loading...",
            Userid: "Loading...",
            Kioskid: "Loading...",
            Email: "Loading...",
            Company: "Loading...",
            Fname: "Loading...",
            Lname: "Loading...",
            Address: "Loading...",
            City: "Loading...",
            State: "Loading...",
            Country: "Loading...",
            Postal: "Loading...",
            Phone: "Loading...",
            CustomerXRef: "Loading...",
            SubscriptionDate: "",
            SubscriptionStatus: false,
            SubscriptionType: "",
            SubscriptionMultiShopCount: 0,
            SubscriptionPrice: 0,
            UserHash: "Loading...",
            UserSalt: "Loading...",
            KioskHash: "Loading...",
            KioskSalt: "Loading...",
            CCNumber: "Loading...",
            CCName: "Loading...",
            CCExpiry: "Loading...",
            CCCvc: "Loading...",
            CCIssuer: "Loading...",
            CCZip: "Loading",
            Processed: "Loading...",
            Notes: "Loading..."
        }
    ],

    subscription:
        {
            RequestingTenantId: "",
            EventType: "",
            Userid: "",
            Kioskid: "",
            Email: "",
            Company: "",
            Fname: "",
            Lname: "",
            Address: "",
            City: "",
            State: "",
            Country: "",
            Postal: "",
            Phone: "",
            CustomerXRef: "",
            SubscriptionDate: "",
            SubscriptionStatus: false,
            SubscriptionType: "",
            SubscriptionMultiShopCount: 0,
            SubscriptionPrice: 0,
            UserHash: "",
            UserSalt: "",
            KioskHash: "",
            KioskSalt: "",
            CCNumber: "",
            CCName: "",
            CCExpiry: "",
            CCCvc: "",
            CCIssuer: "",
            CCZip: "",
            Processed: "",
            Notes: ""
        },
    artists: [
        {
            _id: "",
            Name: "Loading...",
            LiscNumber: "Loading..."
        }
    ],
    artist:
        {
            _id: "",
            Name: "",
            LiscNumber: ""
        },
    clauses: [
        {
            _id: "",
            Type: "Loading...",
            Required: "Loading...",
            Title: "Loading...",
            Text: "Loading..."
        }
    ],
    clause:
        {
            _id: "",
            Type: "",
            Required: "",
            Title: "",
            Text: ""
        },
    consents: [
        {
            _id: "",
            Enabled: false,
            Name: "Loading...",
            TitleImage: "Loading...",
            TitleImagePublicId: "Loading...",
            Header: "Loading",
            AfterSubmit: "Loading...",
            Company: "Loading...",
            EmailTo: "Loading...",
            EmailFrom: "Loading...",
            EmailSubject: "Loading...",
            EmailText: "Loading...",
            EnableCamera: true,
            PhotoRequired: true,
            AgeLimit: "Loading...",
            AskRelation: false,
            EnableNotary: false,
            ParentHeader: "Loading...",
            ConsentFooter: "Loading...",
            RequireName: false,
            RequireAddress: false,
            RequireEmail: false,
            RequirePhone: false,
            RequireNationality: false,
            RequireGender: false,
            IncludedArtists: [],
            IncludedClauses: [],
        }
    ],
    consent:
        {
        _id: "",
        Enabled: false,
        Name: "",
        TitleImage: "",
        TitleImagePublicId: "",
        Header: "",
        AfterSubmit: "",
        Company: "",
        EmailTo: "",
        EmailFrom: "",
        EmailSubject: "",
        EmailText: "",
        EnableCamera: true,
        PhotoRequired: true,
        AgeLimit: "",
        AskRelation: false,
        EnableNotary: false,
        ParentHeader: "",
        ConsentFooter: "",
        RequireName: false,
        RequireAddress: false,
        RequireEmail: false,
        RequirePhone: false,
        RequireNationality: false,
        RequireGender: false,
        IncludedArtists: [],
        IncludedClauses: [],
        dataIncludedClauses: [],
        dataIncludedArtists: [],
        dataAllClauses: [],
        dataAllArtists: [],
        imageChanged: false

    },
    kioskusers: [
        {
            _id: "",
            Name: "Loading...",
            Userid: "Loading...",
            Hash: "Loading...",
            Salt:"Loading...",
            Password: "",
            ConfirmPasswordError: ""
        }
    ],
    kioskuser:
        {
            _id: "",
            Name: "",
            Userid: "",
            Hash: "",
            Salt:"",
            Password:"",
            ConfirmPassword: ""
        },
    submissions: [
        {
            _id: "",
            TenantId: "",
            ConsentId: "",
            ConsentFormName: "Loading...",
            Artist:"Loading...",
            Date: "Loading...",
            ConsentClauses: [],
            ConsentName: "Loading..",
            ConsentAddress: "",
            ConsentPhone: "",
            ConsentEmail: "",
            ConsentNationality: "",
            ConsentGender: "",
            ConsentDOB: "Loading...",
            ConsentAge: "",
            ConsentPhotoId: "",
            ConsentPhotoIdPublicId: "",
            ConsentSignature: "",
            ConsentSignaturePublicId: "",
            ConsentGuardianName: "",
            ConsentGuardianRelation: "",
            ConsentGuardianSignaturePublicId: "",
            ConsentNotes: "",
            ConsentFooter: ""
        }
    ],
    submission:
        {
            _id: "",
            TenantId: "",
            ConsentId: "",
            ConsentFormName: "",
            Artist:"",
            Date:"",
            ConsentClauses: [],
            ConsentName: "",
            ConsentAddress: "",
            ConsentPhone: "",
            ConsentEmail: "",
            ConsentNationality: "",
            ConsentGender: "",
            ConsentDOB: "",
            ConsentAge: "",
            ConsentPhotoId: "",
            ConsentPhotoIdPublicId: "",
            ConsentSignature: "",
            ConsentSignaturePublicId: "",
            ConsentGuardianName: "",
            ConsentGuardianRelation: "",
            ConsentGuardianSignaturePublicId: "",
            ConsentNotes: "",
            ConsentFooter: ""
        },

};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js